export { default } from './LinkedContactCard';
